module.exports = __webpack_public_path__ + "img/about_ico2.6a84fe6d.png";